import "../common";
import "../components/FAQEntry";
import "../components/hotel-list/ClassificationFilter";
import "../components/hotel-list/FilterDialogButton";
import "../components/hotel-list/MultiToggleFilter";
import "../components/hotel-list/ListHeaderCounter";
import "../components/hotel-list/ProgressBar";
import "../components/hotel-list/RecentlyUsedFilters";
import "../components/hotel-list/ResetFilters";
import "../components/hotel-list/Deals";
import "../components/hotel-list/sorting/SelectorMobile";
import "../components/hotel-list/sorting/SelectorDesktop";
import "../components/hotel-list/PriceFilterSection";
import "../components/hotel-list/BoardFilter";
import "../components/hotel-list/ScoreFilter";
import "../admin-tools/ContractStatusFilter";
import "../admin-tools/DiscountFilter";
import "../components/hotel-list/Pagination";
import "../components/tracker/ImpressionInteractionTracker";
import {
	store,
	ACTION_PARSE_HASH,
	ACTION_UPDATE_TRAVEL_DATA,
} from "../components/hotel-list/DataStore";
import { register } from "../components/DialogOpener";
import "../tracker/PerformanceHotelList";

import "../components/hotel-list/HotelList";

// Ads
import * as Stroer from "../components/ads/stroer/Ads";
import "../components/ads/stroer/BannerForList";
import "../components/ads/BookingBanner";
import "../components/ads/google-adsense/ImmediatelyBlock";
import "../components/ads/google-publisher/List";
import "../components/ads/google-publisher/AdContainer";
import "../components/FooterItemLinkNewsletter";
import "@escapio/shared/components/ads/loader/GoogleAdwords";

Stroer.setZone("search");

store.dispatch(ACTION_PARSE_HASH, window.location.hash);
window.onpopstate = () =>
	store.dispatch(ACTION_PARSE_HASH, window.location.hash);

import { onChangeAny, travelData } from "../state/travelData";
onChangeAny(() => store.dispatch(ACTION_UPDATE_TRAVEL_DATA, travelData));

register(() =>
	document.querySelector("esc-search-panel-inputs").openCalendar(),
);

import { data } from "../../shared/state/payload";
import { add as addToHistory } from "../state/history";
import {
	TYPE_CITY,
	TYPE_REGION,
	TYPE_COUNTRY,
} from "../components/GeoTypeConstants";

addToHistory({
	item_id: data.trackingId,
	name: data.articleTitle,
	label: data.articleTitle,
	link: location.pathname,
	type: data.page_search_type,
	type_label: data.page_search_type_label,
	geo_paths: data.geo_path
		? Object.entries(data.geo_path)
				.map(([, { title }]) => title)
				.slice(1)
		: null,
	hotels_number: data.hotel_list.filter(hotel => hotel.distance === -1).length,
	is_alternative: false,
});

import { ListMapDialog } from "../components/map/ListMapDialog";

let mapDialog = null;
document.querySelectorAll("[data-map-dialog-handler]").forEach(button =>
	button.addEventListener("click", event => {
		event.preventDefault();
		mapDialog = mapDialog || new ListMapDialog();
		mapDialog.show();
	}),
);

import { trackSearch } from "../tracker/Facebook";

if (
	data.page_search_type != "combi" &&
	data.geo_path &&
	data.geo_path[TYPE_CITY] &&
	data.hotel_list.length > 0
) {
	trackSearch(
		data.geo_path[TYPE_CITY]?.title,
		data.geo_path[TYPE_REGION]?.title,
		data.geo_path[TYPE_COUNTRY]?.title,
		data.hotel_list.map(hotel => hotel.id),
	);
}
